import type { QueryKey } from '@tanstack/react-query';

import type { ContactFilters } from '../../../services/appStore';

export const CONTACTS_COUNT_BY_COUNTRIES_KEY = 'contactsCountByCountries';
export const makeContactsCountByCountriesQueryKey = ({
  companyLinkedinId,
  domain,
  contactFilters,
}: {
  companyLinkedinId?: string;
  domain?: string;
  contactFilters: ContactFilters;
}) => {
  const { searchText, persona, contactDetails, status } = contactFilters;
  return [
    CONTACTS_COUNT_BY_COUNTRIES_KEY,
    companyLinkedinId,
    domain,
    searchText,
    persona,
    contactDetails,
    status,
  ] as const;
};

export type ContactsCountByCountriesQueryKey = ReturnType<typeof makeContactsCountByCountriesQueryKey>;

export const isContactsCountByCountriesQueryKey = (queryKey: QueryKey): queryKey is ContactsCountByCountriesQueryKey =>
  queryKey[0] === CONTACTS_COUNT_BY_COUNTRIES_KEY;
